import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_URL } from "../../BASE_URL";
import "./social.css";
import Select from "react-select";
import makeAnimated from 'react-select/animated';

const Socialmedia = () => {
    const navigate = useNavigate();

    const [insta, setInsta] = useState("")
    const [face, setFace] = useState("")
    const [twit, setTwit] = useState("")
    const [snap, setSnap] = useState("")


    const handleInstaChange = (e) => {
        setInsta(e.target.value);
    };

    const handleFaceChange = (e) => {
        setFace(e.target.value);
    };

    const handleTwitChange = (e) => {
        setTwit(e.target.value);
    };

    const handleSnapChange = (e) => {
        setSnap(e.target.value);
    };

    const validateUrl = (url) => {
        // Regular expression for a valid URL
        const urlRegex = /^(https?:\/\/)?([\w.]+)\.([a-z]{2,6}\.?)(\/[\w.&%?#=-]*)?$/;
        return urlRegex.test(url);
    }

    const handleSubmit = async () => {
        try {
            const token = localStorage.getItem('saptvidhiUserToken');

            // Build the request payload dynamically
            const requestBody = {};
            if (insta.trim() !== "") {
                if (validateUrl(insta)) {
                requestBody.insta_link = insta;
                }
            }
            if (face.trim() !== "") {
                if (validateUrl(face)) {
                requestBody.fb_link = face;
                }
            }
            if (twit.trim() !== "") {
                if (validateUrl(twit)) {
                requestBody.twitter_link = twit;
                }
            }
            if (snap.trim() !== "") {
                if (validateUrl(snap)) {
                requestBody.snap_chat_link = snap;
            }
            }

            // Check if at least one valid link is provided
            if (Object.keys(requestBody).length === 0) {
                toast.error('Please provide at least one valid social media link!', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 1000,
                });
                return;
            }

            // Make the API call with the dynamically built payload
            const res1 = await fetch(`${BASE_URL}/api/social_media`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify(requestBody),
            });

            if (!res1.ok) {
                toast.error('Failed to submit links!', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 1000,
                });
                return;
            }

            if (res1.ok) {
                toast.success('Link Uploaded successfully!', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 1000,
                });
                setTimeout(() => {
                    navigate("/profile")
                }, 2000);
            } else {
                toast.error('Failed to upload Links!', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 1000,
                });
            }
        } catch (error) {
            toast.error('An unexpected error occurred!', {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 1000,
            });
        }
    };





    return (
        <>
            <div className="social_box mt-5 mb-5">
                <div className="social_in_box">
                    <div className="social_background">
                        <div className="class_for_label mb-4">
                            <h2 className="mb-5 text-center">Social Media</h2>
                            <p className="text-center mb-4">Please provide at least one social media link</p>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div>
                                        <div className="social_media_links">
                                            <h6 className="mb-0">Instagram</h6>
                                            <input
                                                type="text"
                                                name="insta_link"
                                                id="instagram"
                                                placeholder="Enter Your Instagram Account Link (Optional)"
                                                onChange={handleInstaChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mb-3">
                                    <div>
                                        <div className="social_media_links">
                                            <h6 className="mb-0">Facebook</h6>
                                            <input
                                                type="text"
                                                name="fb_link"
                                                id="facebook"
                                                placeholder="Enter Your Facebook Account Link (Optional)"
                                                onChange={handleFaceChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mb-3">
                                    <div>
                                        <div className="social_media_links">
                                            <h6 className="mb-0">X</h6>
                                            <input
                                                type="text"
                                                name="twitter"
                                                id="twitter"
                                                placeholder="Enter Your X Account Link (Optional)"
                                                onChange={handleTwitChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mb-3">
                                    <div>
                                        <div className="social_media_links">
                                            <h6 className="mb-0">Snapchat</h6>
                                            <input
                                                type="text"
                                                name="snap_chat_link"
                                                id="snapchat"
                                                placeholder="Enter Your Snapchat Account Link (Optional)"
                                                onChange={handleSnapChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div id="recaptcha"><ToastContainer /></div>
                        <div className="d-flex">
                            <button className="text-light health_submit" onClick={handleSubmit}>
                                Submit
                            </button>
                        </div>
                        <div className="d-flex justify-content-center mt-3">
                            <NavLink to="/profile" className="text-center" style={{  cursor: "pointer", color: "#f97096" }}>skip</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Socialmedia;
